import { IFloor } from 'spw-redux/modules/projects/types';
import { SCENARIO_LIST_TYPES } from 'spw-components/project-details-tabs/building-details/constants';

export const scenariosTitle = (scenarioListType: string, floor?: IFloor) => {
  if (scenarioListType === SCENARIO_LIST_TYPES.FLOOR) {
    return floor ? floor.name : '';
  }

  if (scenarioListType === SCENARIO_LIST_TYPES.BUILDING) {
    return 'Building';
  }

  if (scenarioListType === SCENARIO_LIST_TYPES.DEPARTMENTS) {
    return 'Departments';
  }

  if (scenarioListType === SCENARIO_LIST_TYPES.MACRO) {
    return 'Macro Programming';
  }

  return '';
};
